import React from 'react';

const OrnamentalDivider = ({ fromColor = "white", toColor = "pink-50", flip = false }) => {
  const getTailwindColor = (color) => {
    const colorMap = {
      'white': '#ffffff',
      'champagne': '#F7E7CE',
      'sand': '#E6D5AC',
      'beige': '#F5E6CC',
      'ivory': '#FFFFF0',
      'wheat': '#F5DEB3',
      'pearl': '#EAE0C8',
      'gold': '#D4AF37',
      'cream': '#FFEFD5'
    };

    // Si el color empieza con 'bg-', quitamos el prefijo
    const cleanColor = color.replace('bg-', '');

    // Retornamos el color mapeado o el color original si no está en el mapa
    return colorMap[cleanColor] || color;
  };

  return (
    <div className="w-full relative z-10 -mb-16">
      <svg
        className={`w-full h-32 ${flip ? 'transform rotate-180' : ''}`}
        viewBox="0 0 1200 120"
        preserveAspectRatio="none"
        style={{
          fill: getTailwindColor(toColor),
          backgroundColor: getTailwindColor(fromColor)
        }}
      >
        <path d="M0,0 C100,60 200,30 300,60 C400,90 500,60 600,60 C700,60 800,90 900,60 C1000,30 1100,60 1200,60 L1200,120 L0,120 Z" />
      </svg>
    </div>
  );
};

export default OrnamentalDivider; 